import { AxiosPromise } from "axios";
import { request } from "utils/request";

export const documentApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/documents",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/documents",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/documents/${id}/staffs`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/documents/${id}`,
      method: "delete",
    }),
  upload: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/documents/upload",
      method: "post",
      data,
    }),
};
